import consumer from "./consumer"

const RenderJobChannel = {
  subscribe(renderJobId, handlers = {}) {
    return consumer.subscriptions.create(
      {
        channel: "RenderJobChannel",
        render_job_id: renderJobId
      },
      {
        connected() {
          console.log(`Connected to render job ${renderJobId}`)
          if (handlers.onConnected) handlers.onConnected()
        },

        disconnected() {
          console.log(`Disconnected from render job ${renderJobId}`)
          if (handlers.onDisconnected) handlers.onDisconnected()
        },

        received(data) {
          console.log("Render job update:", data)
          
          switch(data.type) {
            case "progress":
              if (handlers.onProgress) handlers.onProgress(data)
              break
            case "completed":
              if (handlers.onCompleted) handlers.onCompleted(data)
              break
            case "failed":
              if (handlers.onFailed) handlers.onFailed(data)
              break
            default:
              if (handlers.onUpdate) handlers.onUpdate(data)
          }
        }
      }
    )
  }
}

export default RenderJobChannel
